import { Button, Card, Container } from 'react-bootstrap';
import { Footer } from '../../components/Footer/Footer';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import { formatSecondsTimestamp } from '../../utils/utils';
import { Logo } from '../../components/Logo/Logo';
import { Faq } from '../../components/Faq/Faq';
import { Redirect, useHistory } from 'react-router-dom';
import { Browser } from '@capacitor/browser';
import { useCapacitor } from '../../../hooks/useCapacitor';
import { useStripe } from '@stripe/react-stripe-js';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

const PlatformComingSoonComponent = () => {
  const { staticData, logout, userDataFmt, subscription, plans, promoCodes, addCheckoutSession } = useFirebase();
  const history = useHistory();
  const { isNative } = useCapacitor();
  const stripe = useStripe();

  const [loading, setLoading] = useState(false);

  const handleLogout = async () => {
    history.push('/?logout=1');
    await logout();
    window.location = window.location.pathname as any;
  };

  if (!staticData || !Object.keys(staticData).length || !userDataFmt || !plans?.length || !promoCodes.length) return <FullscreenLoader />;

  if (staticData.PLATFORM_AVAILABLE || userDataFmt.earlyAccess) return <Redirect to={'/'} />;

  const resumeBuyProcess = async (category: 'odontoiatra' | 'aso') => {
    setLoading(true);
    const { price, promo } = getLaunchOffer(category);
    try {
      const { sessionId, url } = await addCheckoutSession(price, promo);
      if (isNative) {
        await Browser.open({ url });
      } else await stripe.redirectToCheckout({ sessionId });
    } catch (e) {
      try {
        alert(JSON.stringify(e, null, 2));
      } catch {
        alert(e);
      }
    }
  };

  const getLaunchOffer = (category: 'odontoiatra' | 'aso', interval: 'year' = 'year') => {
    const plan = plans.find((plan) => plan.metadata?.CATEGORY == category && plan.prices.find((price) => price.interval == interval));
    const price = plan.prices.find((price) => price.active && price.interval == 'year').id;
    const promo = promoCodes.find((promoCode) => promoCode.metadata?.CATEGORY == category).id;
    return { price, promo };
  };

  return (
    <>
      <Container className={'my-5 text-center'}>
        <Logo style={{ height: '64px' }} />
        <h1 className={'mt-5'}>Arriviamo presto!</h1>
        {!!staticData.PLATFORM_AVAILABLE_FROM && (
          <p>La piattaforma sarà accessibile dal giorno {formatSecondsTimestamp(staticData.PLATFORM_AVAILABLE_FROM._seconds)}.</p>
        )}

        {!isNative && !!userDataFmt.profile?.formData?.categoriaProfessionale && !subscription && (
          <Card bg={'dark'} className={'mt-5 mx-auto'} style={{ maxWidth: '600px' }}>
            <Card.Header>
              <Card.Title className={'mb-0'}>Non farti sfuggire l'esclusiva offerta lancio!</Card.Title>
            </Card.Header>
            <Card.Body>
              {userDataFmt.profile.formData.categoriaProfessionale == 'odontoiatra' && (
                <div>Risparmia più del 25% sul normale costo dell'abbonamento annuale</div>
              )}
              {userDataFmt.profile.formData.categoriaProfessionale == 'aso' && (
                <div>Risparmia più del 33% sul normale costo dell'abbonamento e accedi a video validi per l'aggiornamento annuale obbligatorio 10 ore</div>
              )}
            </Card.Body>
            <Card.Footer>
              <Button variant={'primary'} disabled={loading} onClick={() => resumeBuyProcess(userDataFmt.profile.formData.categoriaProfessionale)}>
                {loading ? 'Attendi...' : "Clicca qui per procedere all'acquisto"}
              </Button>
            </Card.Footer>
          </Card>
        )}

        {!!subscription && (
          <Card bg={'dark'} className={'mt-5 mx-auto'} style={{ maxWidth: '600px' }}>
            <Card.Body>
              <div className={'text-success d-flex align-items-center justify-content-center h5 mb-0'}>
                <FontAwesomeIcon className={'mr-2'} icon={faCheckCircle} />
                <div>Hai un abbonamento attivo</div>
              </div>
            </Card.Body>
          </Card>
        )}

        <div className={'my-5'}>
          <Button variant={'secondary'} disabled={loading} size={'sm'} onClick={() => handleLogout()}>
            Torna indietro
          </Button>
        </div>

        <Faq />
      </Container>

      <Footer />
    </>
  );
};

export default PlatformComingSoonComponent;
